import { FC, lazy, useEffect } from "react";
import AuthLayout from "../layouts/AuthLayout";
import useRoutes from "ui-modules/commons/hooks/use-routes";
import CreateRoutes from "ui-modules/components/Navigation/Routes/CreateRoutes";

// const Login = lazy(() => import("../container/Login"));
const ForgetPassword = lazy(() => import("../container/ForgetPassword"));
const Login2fa = lazy(() => import("../container/Login2fa"));

const routes = [
  {
    path: "/auth/login",
    exact: true,
    inSecure: true,
    component: Login2fa,
    // component: Login,
  },
  {
    path: "/auth/forget-password",
    exact: true,
    inSecure: true,
    component: ForgetPassword,
  },
  // {
  //   path: "/auth/login/test/2fa",
  //   exact: true,
  //   inSecure: true,
  //   component: Login1,
  // },
];

const AuthApp: FC = () => {
  const { setRoutes } = useRoutes();

  useEffect(() => {
    setRoutes(routes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthLayout>
      <CreateRoutes />
    </AuthLayout>
  );
};

export default AuthApp;
